import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="container-fixed">
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
          <div className="flex order-2 md:order-1 gap-2 font-normal text-2sm">
            <span className="text-gray-500">{new Date().getFullYear()}©</span>
            <p
              className="text-gray-5D5D5D font-medium"
            >
              Trustoo.
            </p>
            <a
              className="text-gray-500 border-l border-gray-300 px-2 pl-4 cursor-pointer"
              onClick={() => navigate('/privacy-policy')}
            >
              {t('privacyPolicy')}
            </a>
            <a 
              className="text-gray-500 border-l border-gray-300 px-2 pl-4 cursor-pointer"
              onClick={() => navigate('/cgu')}
            >
              CGU
            </a>
            <a
              className="text-gray-500 border-l border-gray-300 px-2 pl-4 cursor-pointer"
              onClick={() => navigate('/legal-mention')}
            >
              {t('legalMentions')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
